import { gql } from '@apollo/client';

export const deleteConferenceQuery = gql`
  mutation deleteConference($conferenceId: String!) {
    deleteConference(conferenceId: $conferenceId)
  }
`;
